export const AGREEMENT_CONFIRMINATION = 'AGREEMENT_CONFIRMINATION';

export function agreementConfirmination(agreementType) {
  return {
    type: AGREEMENT_CONFIRMINATION,
    agreementType,
  };
}
